import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideInfoBox from 'pages/guide/components/GuideInfoBox';
import GuideLink from 'pages/guide/components/GuideLink';
import GuidePageLayout from 'pages/guide/components/GuidePageLayout';
import GuideSection from 'pages/guide/components/GuideSection';
import GuideTable from 'pages/guide/components/GuideTable';

const GuideDeployOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="デプロイ概要"
      description="フロントエンド・バックエンドのデプロイ構成と手順の概要です。"
    >
      <GuideInfoBox type="warning">
        本セクションはDEVELOPER権限を持つユーザーのみ閲覧できます。
      </GuideInfoBox>

      <GuideSection title="システム構成">
        <Stack spacing={1.5}>
          <GuideTable
            headers={['コンポーネント', 'ホスティング先', 'URL']}
            rows={[
              ['フロントエンド（React SPA）', 'S3 + CloudFront', 'https://portal.kanzhong.app'],
              ['バックエンド（Spring Boot）', 'ECS Fargate + ALB', 'https://api.kanzhong.app'],
            ]}
          />
        </Stack>
      </GuideSection>

      <GuideSection title="デプロイ方式">
        <Stack spacing={1.5}>
          <Typography variant="body2" color="text.secondary">
            通常は main ブランチへのプッシュで GitHub Actions が自動デプロイを実行します。
            手動デプロイは緊急時やデバッグ時のみ使用してください。
          </Typography>
          <GuideTable
            headers={['方式', 'トリガー', '用途']}
            rows={[
              ['自動デプロイ', 'main ブランチへのプッシュ', '通常のリリース'],
              ['手動デプロイ', 'ローカルからコマンド実行', '緊急対応・デバッグ'],
            ]}
          />
        </Stack>
      </GuideSection>

      <GuideSection title="手順ページ">
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            各コンポーネントの具体的な手動デプロイ手順は以下を参照してください。
          </Typography>
          <Stack spacing={0.5} sx={{ pl: 1 }}>
            <GuideLink to="deploy/frontend">フロントエンド手動デプロイ手順</GuideLink>
            <GuideLink to="deploy/backend">バックエンド手動デプロイ手順</GuideLink>
            <GuideLink to="deploy/db-access">踏み台経由DB接続手順</GuideLink>
          </Stack>
        </Stack>
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>
            認証情報（AWS
            アカウントID、ECRリポジトリ名、S3バケット名等）は本ガイドに含まれていません。別途管理されているドキュメントを参照してください。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideDeployOverview;
